import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  managePlan: {
    description: 'text for the button a user can click to manage their subscription plan',
    defaultMessage: 'Edit',
    id: 'ZLrAoh',
  },
  hasAddonsTextPriceless: {
    description: 'text indicating an account has additional add on features',
    defaultMessage: '<link>Add-ons</link>',
    id: 'bTQMcO',
  },
  chooseAPlan: {
    description: 'button for trials to choose a plan',
    defaultMessage: 'Choose a Plan',
    id: 'u6QJBo',
  },
  subscriptionsOnlyHeader: {
    description: 'subscription page header',
    defaultMessage: 'Subscription',
    id: 'yiXEYY',
  },
  subscriptionsOnlySubDescription: {
    description: 'settings page subscription subDescription',
    defaultMessage: 'Update your plan, billing information, or download your monthly data archives.',
    id: 'UCJf/5',
  },
  currentSubscription: {
    description: 'settings page current subscription header',
    defaultMessage: 'Current Subscription',
    id: 'mBBC8e',
  },
  yourPlan: {
    description: 'settings page your plan header',
    defaultMessage: 'Your Plan',
    id: 'YbSG+5',
  },
  nextInvoice: {
    description: 'settings page your plan header',
    defaultMessage: 'Next Invoice',
    id: 'Z34zQf',
  },
  billingInformation: {
    description: 'settings page billing information header',
    defaultMessage: 'Subscription Billing Information',
    id: 'QAEbhO',
  },
  dataArchive: {
    description: 'settings page data archive header',
    defaultMessage: 'Data Archive',
    id: 'i5iN1O',
  },
  dataArchiveDescription: {
    description: 'settings page data archive description',
    defaultMessage:
      'Every month, ShipStation archives your order data. Click <a>here</a> to view your monthly archive and download your data.',
    id: 'R2Wl2Z',
  },
  taxNote: {
    description: 'settings page tax notice',
    defaultMessage: 'Note: Plans are billed in USD and subject to applicable taxes, if any.',
    id: 'S8gwbF',
  },
  inTrialNoInvoiceNotice: {
    description: 'settings page in trial no invoice date notice',
    defaultMessage: 'There are no invoices to pay during the trial subscription period.',
    id: 'QEyOm7',
  },
  planName: {
    description: 'subscription plan name and cost',
    defaultMessage: '{name} for {price} per month',
    id: 'UBmKtL',
  },
  unlimitedSellingChannels: {
    description: 'settings.api.managingOrders',
    defaultMessage: 'Unlimited Selling Channels',
    id: '/BZcee',
  },
  numberOfShipments: {
    description: 'settings.api.managingShipments',
    defaultMessage: '{number} Shipments',
    id: 'rOZGVR',
  },
  numberOfUsers: {
    description: 'settings.api.creatingShippingLabels',
    defaultMessage: '{number, plural, one {# User} other {# Users}}',
    id: '4HPBi5',
  },
  unlimited: {
    description: 'subscription unlimited',
    defaultMessage: 'Unlimited',
    id: 'hjlgkE',
  },
  unlimitedShipments: {
    description: 'unlimited shipments',
    defaultMessage: 'Unlimited Shipments',
    id: 'cVr4g5',
  },
  creditCardDeclined: {
    description: 'subscription credit card declined message',
    defaultMessage:
      'The card on file has expired or has insufficient funds. Please check the card and <a>update the payment method</a> to continue your subscription.',
    id: '9bXL/C',
  },
  payPalDeclined: {
    description: 'subscription paypal declined message',
    defaultMessage:
      'The PayPal account on file has expired or has insufficient funds. Please check the account and <a>update the payment method</a> to continue your subscription.',
    id: '5G1F79',
  },
  cancellationNotYetEffectiveEndDateUnknown: {
    description: 'cancellation requested but not yet effective until unknown date',
    defaultMessage:
      'At your request, on <b>{cancelledDate}</b>, your subscription plan was set to cancelled status. Your account will remain active until <b>the end of your next billing cycle</b>. You may continue to use ShipStation until that time.',
    id: '1owG5c',
  },
  cancellationNotYetEffectiveEndDateKnown: {
    description: 'cancellation requested but not yet effective until specified date',
    defaultMessage:
      'At your request, on <b>{cancelledDate}</b>, your subscription plan was set to cancelled status. Your account will remain active until <b>{endDate}</b>. You may continue to use ShipStation until that time.',
    id: 'GjlgCQ',
  },
  cancellationInEffect: {
    description: 'cancellation in effect notice',
    defaultMessage:
      'At your request, on <b>{cancelledDate}</b>, your subscription plan was set to cancelled status. Your account is no longer active and you are not eligible to continue using ShipStation.',
    id: '6b4+Fv',
  },
  ctpCancellationNotice: {
    description: 'subscription restart prompt for CTP program users',
    defaultMessage:
      'If you wish to reactivate your cancelled CTP Program subscription, please contact your ShipStation account manager for assistance.',
    id: 'tCMINn',
  },
  restartSubscriptionCancellationNotYetEffective: {
    description: 'subscription restart prompt when cancellation is not yet in effect',
    defaultMessage: "If you wish to reactivate your cancelled subscription, <a>please click here and we'll take care of it for you</a>.",
    id: 'tNZ29g',
  },
  restartSubscriptionCancellationInEffectOrTrialExpired: {
    description: 'subscription restart prompt if cancellation in effect or trial has expired',
    defaultMessage:
      'Your progress has been saved and is still available. By clicking the <b>Change Your Subscription</b> button below you can select the plan that’s right for you and pick up right where you left off.',
    id: 'gjTrDQ',
  },
  stampsAccountBillingNotice: {
    description: 'stamps plan will revert back to user paying the cost notice',
    defaultMessage:
      'If you previously linked a billed Stamps.com account to ShipStation, that linked Stamps.com account will now revert to a billed Stamps.com plan so your service with Stamps.com will continue uninterrupted.',
    id: 'wuxU/b',
  },
  expiredTrialTitle: {
    description: 'trial is expired title message',
    defaultMessage: 'Your trial has expired.',
    id: '2/iekO',
  },
  additionalUsersMessage: {
    description: 'message about extra users on plan',
    defaultMessage: '({numberOfAdditionalUsers} extra {numberOfAdditionalUsers, plural, one {User} other {Users}} at {price} each)',
    id: 'y6NNYl',
  },
  fulfillmentProviderBundlePlanDetails: {
    description: '3pl provider bundle plan details line item',
    defaultMessage: '3PL Provider Bundle {inBundleTrial, select, true {(free trial)} false {($50 per month)} other {}}',
    id: 'wVvKJ3',
  },
  squareBillingInvoiceMessage: {
    description: 'message to direct users to Square to see invoices',
    defaultMessage: 'Please <a>login</a> to <b>Square</b> to review your payment history.',
    id: 'GSDBnc',
  },
  freePlanNoInvoiceMessage: {
    description: 'no invoices message',
    defaultMessage:
      'Your plan type does not require invoicing or payments directly from you. No invoices are available within ShipStation.',
    id: '3/YjgU',
  },
  nextInvoiceDate: {
    description: 'next invoice date message',
    defaultMessage: '<b>{endDatePlusMonth}</b> Automatically paid. View your <a>past invoices</a>.',
    id: '8s3AQd',
  },
  changePlan: {
    description: 'change subscription link',
    defaultMessage: 'Change Plan',
    id: '/i1T1V',
  },
  renewPlan: {
    description: 'Renew plan link for users who have cancelled their accounts',
    defaultMessage: 'Renew Plan',
    id: 'Ax4JoS',
  },
  undoCancellation: {
    description: 'Undo cancellation link for users who have cancelled their accounts',
    defaultMessage: 'Undo Cancellation',
    id: '7YhecG',
  },
  chooseSubscription: {
    description: 'choose subscription plan link',
    defaultMessage: 'Choose a Subscription Plan',
    id: 'YjH7vl',
  },
  noBillingOnFile: {
    description: 'no billing info on file message',
    defaultMessage:
      'You currently do not have a payment method set for your monthly ShipStation subscription. Click the <b>Update Subscription Billing</b> button to enter your payment details.',
    id: 'PRC8wO',
  },
  updateWalletBilling: {
    description: 'no billing info on file message with account that has a wallet',
    defaultMessage: 'To update billing for {walletBrandName}, go to the <link>Carriers Page</link>.',
    id: 'Iar2Ya',
  },
  ShipsuranceMessage: {
    description: 'message describing that the subscripton payment method will also be used for Shipsurance',
    defaultMessage: 'This payment method will also be used for Shipsurance, the discount insurance program included with ShipStation.',
    id: 'AVxk+E',
  },
  squareBillingLink: {
    description: 'change billing info with Square message',
    defaultMessage:
      'To change your ShipStation payment information, you must login to your <b>Square</b> account <a>here</a> and update your billing information.',
    id: 'qeo1px',
  },
  ctpBillingLink: {
    description: 'change billing info for CTP plans message',
    defaultMessage:
      'To make changes to your ShipStation subscription plan you must reach out to ShipStation Support via <a>support@shipstation.com</a> or your UPS Account Manager.',
    id: '1Xi+My',
  },
  updateBillingNoWallet: {
    description: 'change billing info message with no wallet',
    defaultMessage: 'Click the <b>Update Subscription Billing</b> button to change your ShipStation subscription payment details.',
    id: 'vQTwp2',
  },
  billingInfoIsJustForShipStation: {
    description: 'change billing info with account that has a wallet',
    defaultMessage:
      '<b>This billing information is for your ShipStation subscription only.</b> To update billing for {walletBrandName}, select "Update payment method" on the <link>Carriers Page</link>.',
    id: 'LMNhl6',
  },
  updateWalletBillingWithShipsurance: {
    description: 'change billing info with an account that has a wallet and Shipsurance',
    defaultMessage:
      '<b>This billing information is for your ShipStation subscription and Shipsurance balance only.</b> To update billing for {walletBrandName}, select "Update payment method" on the <link>Carriers Page</link>.',
    id: 'mBjPbd',
  },
  billingAddress: {
    description: 'billing address header',
    defaultMessage: 'Billing Address',
    id: 'T7pBvB',
  },
  billingMethod: {
    description: 'billing method header',
    defaultMessage: 'Billing Method',
    id: 'zwaqMz',
  },
  changeBillingInformation: {
    description: 'change billing information link',
    defaultMessage: 'Update Subscription Billing',
    id: 'IZ/2Ri',
  },
  expirationYear: {
    description: 'billing information expiration year',
    defaultMessage: 'Expiration Year',
    id: 'likIQl',
  },
  subscriptionModalConfirmExitHeader: {
    description: 'Header text to exit ShipStation Subscription Plan Change before saving their selection',
    defaultMessage: 'Exit Subscription Plan Change',
    id: 'yMW6XO',
  },
  subscriptionModalConfirmExitBody: {
    description: 'Body text to exit ShipStation Subscription Plan Change',
    defaultMessage: 'Are you sure you want to exit before saving changes to your subscription plan?',
    id: 'NZ1BuF',
  },
  subscriptionModalConfirmExitButton: {
    description: 'Button text to exit ShipStation Subscription Plan Change',
    defaultMessage: 'Exit',
    id: 'Hov7N+',
  },
  manageSubscriptionModalHeader: {
    description: 'change subscription modal header',
    defaultMessage: 'ShipStation Subscription Plan',
    id: 'XxvVK9',
  },
  trialManageSubscriptionModalHeader: {
    description: 'in trial manage subscription modal header',
    defaultMessage: "We'd be glad to have you on board. Here are some things to know:",
    id: 'ar9LKf',
  },
  trialNoContractsMessage: {
    description: 'in trial no contracts message',
    defaultMessage: 'No long term contracts.',
    id: 'hHstTk',
  },
  trialChangePlanAtAnyTimeMessage: {
    description: 'in trial chnage plan at any time message',
    defaultMessage: 'Change your plan whenever. Upgrade or downgrade anytime, you’re not locked in.',
    id: 'drFfD1',
  },
  trialNoHiddenFeesMessage: {
    description: 'in trial no hidden fees message',
    defaultMessage: 'No hidden fees. Your subscription fee includes everything except for postage and insurance.',
    id: 'z7OH+2',
  },
  trialRefundMessage: {
    description: 'in trial refund message',
    defaultMessage: 'Change your mind? Cancel within your first 90 days and get a full refund.',
    id: '1sL88p',
  },
  trialNotSureWhichPlanMessage: {
    description: 'in trial not sure which plan message',
    defaultMessage: '<b>Not sure which plan you need?</b>',
    id: '0erHFW',
  },
  trialBasedOnPlanMessage: {
    description: 'in trial based on usage message',
    defaultMessage: '<b>Based on your usage:</b>',
    id: 'xkVFp3',
  },
  trialOrderUsageSuggestion: {
    description: 'in trial order usage suggestion',
    defaultMessage: '<b>{numberOfOrders}</b> {numberOfOrders, plural, one {order} other {orders}} in 30 days of use.',
    id: 'ge2eCy',
  },
  trialMarketplaceUsageSuggestion: {
    description: 'in trial marketplace usage suggestion',
    defaultMessage: '<b>{numberOfPlatforms}</b> {numberOfPlatforms, plural, one {platform} other {platforms}} connected.',
    id: 'nVcGPk',
  },
  trialUserUsageSuggestion: {
    description: 'in trial user usage suggestion',
    defaultMessage: '<b>{numberOfUsers}</b> {numberOfUsers, plural, one {user} other {users}}.',
    id: 's96Iu1',
  },
  trialBestChoice: {
    description: 'in trial best choice',
    defaultMessage: '<b>Best choice</b>',
    id: 'hxhTdx',
  },
  trialSuggestedPlanPricePerMonth: {
    description: 'in trial suggested plan price per month',
    defaultMessage: '<b>{suggestedPlanSymbol}{suggestedPlanPrice} per month</b>',
    id: 'KwjqCz',
  },
  trialSelectPlanButton: {
    description: 'in trial select plan button',
    defaultMessage: 'Select Plan',
    id: '9bdOUY',
  },
  trialReadyToStart: {
    description: 'in trial ready to start plan header',
    defaultMessage: 'Ready to start your subscription now?',
    id: 'lGXH2q',
  },
  suggestedPlanCost: {
    description: 'suggested plan cost',
    defaultMessage: '{price} per month',
    id: 'O3Aqwi',
  },
  selectPlan: {
    description: 'select plan button',
    defaultMessage: 'Select Plan',
    id: 'T93yRe',
  },
  currentSubChangePlanHeader: {
    description: 'change plan header',
    defaultMessage: 'Change your plan at any time.',
    id: 'TJSl8G',
  },
  currentSubImportantInfoChangePlan: {
    description: 'change plan list of info to know',
    defaultMessage: 'Important info to know when changing plans:',
    id: 'CzQxoX',
  },
  upgradeBillingInfo: {
    description: 'change plan upgrade pro-rate info',
    defaultMessage:
      'Upgrades happen immediately. The cost difference is prorated based on the days remaining in your current billing cycle.',
    id: '7BEWzi',
  },
  downgradeBillingInfo: {
    description: 'change plan downgrade pro-rate info',
    defaultMessage: 'Downgrades process at the end of your current billing cycle.',
    id: 'D9bUrs',
  },
  accountAddOnsTitle: {
    description: 'account add-ons title',
    defaultMessage: '<b>Account Add-ons:</b>',
    id: 'gajANT',
  },
  updateSubscriptionAddOnsButton: {
    description: 'update account additional users button',
    defaultMessage: 'Update Subscription Add-ons',
    id: 'IyD3oe',
  },
  readyToRestart: {
    description: 'cancelation ready to restart message',
    defaultMessage: 'Ready to re-start your subscription now?',
    id: '+W+Kfv',
  },
  backOnBoardThingsToKnow: {
    description: 'cancelation restart billing info list',
    defaultMessage: "We'd be glad to have you back on board. Here are some things to know:",
    id: 'GqWDA7',
  },
  pricePerMonth: {
    description: 'plan price per month',
    defaultMessage: 'Price per Month',
    id: 'XijN0k',
  },
  perLabelFee: {
    description: 'plan fee per label (Bring Your Own Carriers)',
    defaultMessage: 'Per shipment when using your carrier rates',
    id: 'JvrvxD',
  },
  shipmentsPerMonth: {
    description: 'plan shipments per month',
    defaultMessage: 'Shipments per Month',
    id: 'mpejNd',
  },
  ordersPerMonth: {
    description: 'plan orders per month',
    defaultMessage: 'Orders per Month',
    id: 'vR9yQq',
  },
  sellingChannelsLimit: {
    description: 'plan Selling Channels limit',
    defaultMessage: 'Selling Channels',
    id: 'Mkx6ez',
  },
  planUsersLimit: {
    description: 'plan Users limit',
    defaultMessage: 'Included users',
    id: 'pUjlYK',
  },
  planCarrierLimit: {
    description: 'plan carrier limit',
    defaultMessage: 'Carriers',
    id: 'vK+auI',
  },
  uspsCarrier: {
    description: 'USPS carrier name',
    defaultMessage: 'USPS',
    id: 's1sUFN',
  },
  planPackingSlipsAndLabelsBranding: {
    description: 'plan Packing Slips / Labels branded or customized feature',
    defaultMessage: 'Packing Slips',
    id: 'X4ZGb2',
  },
  standard: {
    description: 'plan Packing Slips / Labels standard',
    defaultMessage: 'Standard',
    id: 'gsao/6',
  },
  branded: {
    description: 'plan Packing Slips / Labels brandede',
    defaultMessage: 'Branded',
    id: '//qQWj',
  },
  customizable: {
    description: 'plan Packing Slips / Labels customizable',
    defaultMessage: 'Customizable',
    id: 'oSlcpq',
  },
  customized: {
    description: 'plan Packing Slips / Labels customized',
    defaultMessage: 'Customized',
    id: 'uy5Ce+',
  },
  bespoke: {
    description: 'plan Packing Slips / Labels bespoke',
    defaultMessage: 'Bespoke',
    id: 'ApSHLg',
  },
  planSupportLevel: {
    description: 'plan support level',
    defaultMessage: 'Support',
    id: 'rdvqqa',
  },
  planPremiumFeatures: {
    description: 'plan Premium Features heading',
    defaultMessage: 'Premium Features',
    id: '/wKPhf',
  },
  selectPlanButton: {
    description: 'select plan button label',
    defaultMessage: 'Select Plan',
    id: 'wL3bNj',
  },
  currentPlan: {
    description: 'current plan label',
    defaultMessage: 'Current',
    id: 'yn6Vb3',
  },
  recommendedPlan: {
    description: 'Recommended plan label',
    defaultMessage: 'Recommended',
    id: 'eqay3i',
  },
  pendingPlan: {
    description: 'pending plan label',
    defaultMessage: 'Pending',
    id: 'zZmTdM',
  },
  emailSupport: {
    description: 'email support indicator',
    defaultMessage: 'Email',
    id: '4aF46A',
  },
  liveChatSupport: {
    description: 'live chat support indicator',
    defaultMessage: 'Live Chat',
    id: 'jHgC6i',
  },
  phoneSupport: {
    description: 'phone support indicator',
    defaultMessage: 'Phone',
    id: '0gfU9z',
  },
  plansSubjectToUSTaxesNotice: {
    description: 'plans subject to US taxes notice',
    defaultMessage: 'Note: Plans are billed in USD and subject to applicable taxes, if any.',
    id: 'CKCJtB',
  },
  plansSubjectToTaxesNotice: {
    description: 'plans subject to taxes notice',
    defaultMessage: 'Note: Plans are subject to applicable taxes, if any.',
    id: 'IwdZPK',
  },
  howSubscriptionWorksNotice: {
    description: 'description of how the subscription works',
    defaultMessage:
      'If you decide to continue past your free trial period and select a paid plan, you will be charged a monthly subscription fee that reflects the plan you select. For your convenience, once you have activated your subscription, your ShipStation service will continue uninterrupted unless you decide to cancel. Your payment method may also be used to pay for postage and optional services.{br}You can cancel online or reach out to <a>{email}</a>.',
    id: 'yfX6Zg',
  },
  howAnnualSubscriptionWorksNotice: {
    description: 'description of how annual subscription works',
    defaultMessage:
      'If you decide to continue past your free trial period and select a paid plan, you will be charged an annual subscription fee that reflects the plan you select. For your convenience, once you have activated your subscription, your ShipStation service will continue uninterrupted unless you decide to cancel. To switch off of annual billing, please contact support. Your payment method may also be used to pay for postage and optional services.{br}You can cancel online or reach out to <a>{email}</a>.',
    id: 'DzzPi4',
  },
  planNameLabel: {
    description: 'plans name label for plan table',
    defaultMessage: 'Plan Name',
    id: 'b+Ytca',
  },
  highVolumeShipmentLimit: {
    description: 'High volume shipment plan limit text',
    defaultMessage: '10000 included, then {costPerExtraShipment} per shipment',
    id: 'eoNfty',
  },
  highVolumeShipmentLimitVariable: {
    description: 'number of shipments included in High volume plan, including cost per shipment once the limit is reached',
    defaultMessage: '{limit} included, then {costPerExtraShipment} per shipment',
    id: 'kEzDO5',
  },
  tenPlus: {
    description: 'ten plus message',
    defaultMessage: '10+',
    id: 'ZpZlyV',
  },
  tenThousandPlus: {
    description: 'ten thousand plus message',
    defaultMessage: '10000+',
    id: 'uEYltc',
  },
  updateBillingInfoSuccessTitle: {
    description: 'success notification title for updating billing info',
    defaultMessage: 'Success!',
    id: 'E5hzeZ',
  },
  updateBillingInfoSuccessWithoutWallet: {
    description: 'success notification message body',
    defaultMessage: 'The billing information for your subscription has been updated.',
    id: '64nSs6',
  },
  updateBillingInfoSuccessWithWallet: {
    description: 'success notification message body with reminder to update wallet payment method as well',
    defaultMessage:
      'The billing information for your subscription has been updated. If you also need to update billing for {walletBrandName}, go to the <link>Carriers Page</link>.',
    id: '/VvMnc',
  },
  newUpdateBillingInfoSuccessWithWallet: {
    description: 'success notification message body with reminder to update wallet payment method as well',
    defaultMessage: 'The billing information for your ShipStation subscription has been updated.',
    id: 'rFWHxM',
  },
  failedToChangePlan: {
    description: 'notification text for failed plan change',
    defaultMessage: 'Failed to change billing plan, please try again',
    id: '8S7hhI',
  },
  cardDeclined: {
    description: 'notification text for card declined',
    defaultMessage: 'Your billing information was declined, please update your payment method and try again',
    id: 'EPFIbq',
  },
  failedToUpdateAddOns: {
    description: 'notification text for failed add on update',
    defaultMessage: 'Failed to update plan add ons, please try again',
    id: 'TsOyLx',
  },
  failedToUpdateUser: {
    description: 'notification text for failed user deactivation',
    defaultMessage: 'Failed to deactivate user, please try again',
    id: 'L7UFtv',
  },
  updateAddOnsSuccess: {
    description: 'notification text for failed add on update',
    defaultMessage: 'Updated plan add ons successfully!',
    id: '+vwDxS',
  },
  userAddOnModalHeader: {
    description: 'user add on update modal header',
    defaultMessage: 'Update Plan Add-ons',
    id: 'fYXzgw',
  },
  manageUsersAddOnHeader: {
    description: 'Manage user modal header',
    defaultMessage: 'Manage Users',
    id: '4g0PPS',
  },
  howManySeats: {
    description: 'Information about included user seats in a plan and the additional cost for more user seats.',
    defaultMessage:
      '{userCount} account users are included in the {planName} plan, {price} each additional user. {br} To remove a user, click <i>Deactivate</i> and they will be immediately removed. To manage users go to <i>Account > User Management</i>',
    id: 'bntzQK',
  },
  additionalUsersList: {
    description: 'additional users list title',
    defaultMessage: 'Active Users: {userCount}',
    id: 'VI7pQO',
  },
  approveAndUpdate: {
    description: 'approve user add ons and change plan',
    defaultMessage: 'Approve & Update Plan',
    id: 'iBIPqn',
  },
  updatePlan: {
    description: 'update plan chnage button',
    defaultMessage: 'Update Plan',
    id: 'kCkGMO',
  },
  deactivate: {
    description: 'deactivate user button',
    defaultMessage: 'Deactivate',
    id: 'bjYYfC',
  },
  reactivate: {
    description: 'reactivate user button',
    defaultMessage: 'Reactivate',
    id: 'Ja2ayq',
  },
  deactivated: {
    description: 'deactivated user label',
    defaultMessage: 'Deactivated',
    id: 'PnZ/+6',
  },
  contactAdministrator: {
    description: 'deactivate user button disabled message',
    defaultMessage: 'Only users with Administrator permissions may deactivate users',
    id: '0Eksvl',
  },
  currentUser: {
    description: 'current user',
    defaultMessage: '(Current User)',
    id: 'M+N8Li',
  },
  userName: {
    description: 'active user name',
    defaultMessage: 'Name',
    id: 'lEAmXA',
  },
  userLastLoginDate: {
    description: 'active user last login date',
    defaultMessage: 'Last Login Date',
    id: 'oQTo3I',
  },
  invoicesGridLabel: {
    description: 'Invoices view label',
    defaultMessage: 'Invoices',
    id: '0PNa+7',
  },
  invoiceDate: {
    description: 'Invoices date column header',
    defaultMessage: 'Date',
    id: 'xL77U4',
  },
  invoiceNumber: {
    description: 'Invoices number column header',
    defaultMessage: 'Invoice #',
    id: 'xjs8Cx',
  },
  invoiceSubtotal: {
    description: 'Invoices subtotal column header',
    defaultMessage: 'Subtotal',
    id: '4YAitm',
  },
  invoiceTotal: {
    description: 'Invoices total column header',
    defaultMessage: 'Total',
    id: 'FZjwq2',
  },
  invoiceDownload: {
    description: 'Invoices download column header',
    defaultMessage: 'Download',
    id: 'NaYlKP',
  },
  invoiceGridDescription: {
    description: 'Invoices grid description',
    defaultMessage: 'These invoices represent your subscription charges billed by ShipStation.',
    id: 'Mh2PNZ',
  },
  invoiceGridSupport: {
    description: 'Invoices grid support notice',
    defaultMessage: 'Please direct any questions regarding your billing history to <a>our support team</a>.',
    id: 'NH0Skl',
  },
  archiveMonth: {
    description: 'Archive grid month column header',
    defaultMessage: 'Month',
    id: 'lYbNJE',
  },
  archiveNumberOfOrders: {
    description: 'Archive grid number of orders column header',
    defaultMessage: '# Orders',
    id: 'gmVFb3',
  },
  archiveNumberOfShipments: {
    description: 'Archive grid number of shipments column header',
    defaultMessage: '# Shipments',
    id: 'mLdR+3',
  },
  archiveOrderTotal: {
    description: 'Archive grid order total column header',
    defaultMessage: 'Order Total',
    id: 'HNSpk3',
  },
  archiveShippingTotal: {
    description: 'Archive grid shipping total column header',
    defaultMessage: 'Shipping Total',
    id: '82iNHj',
  },
  archiveDownload: {
    description: 'Archive grid download column header',
    defaultMessage: 'Download',
    id: 'TIht+v',
  },
  archiveGridLabel: {
    description: 'Archive grid label',
    defaultMessage: 'Monthly Archive',
    id: 'uX/LVw',
  },
  archiveGridDescription: {
    description: 'Invoices grid description notice',
    defaultMessage:
      'Your data is archived monthly in ShipStation. You can download this information by clicking the "Download" link below and next to the month you wish to download.',
    id: '6GfTwT',
  },
  customPrice: {
    description: 'plan grid note that plan has custom pricing',
    defaultMessage: 'Custom',
    id: 'elD2LO',
  },
  cancelSubscriptionModalHeader: {
    description: 'cancel subscription modal header',
    defaultMessage: 'Cancel Your ShipStation Subscription Plan',
    id: '/3TMSh',
  },
  howToCancelSubscription: {
    description: 'cancel subscription instructions',
    defaultMessage: "If you're sure you'd like to cancel your subscription, finish below.",
    id: 'NUBXq8',
  },
  cancelledSubscriptionWillContinueUntilAndOneBalanceRefundDisclaimer: {
    description: 'cancelled subscription will continue until date',
    defaultMessage:
      'Your current subscription will continue until <b>{cancellationEffectiveDate}</b>. You can continue to use ShipStation through the end of your current subscription. If you have a balance of funds at the end of your billing cycle, ShipStation will automatically process a refund in the next 30 business days.',
    id: 'oM5NlY',
  },
  feedbackMatters: {
    description: 'cancellation feedback notice',
    defaultMessage: "We're always improving our service and your feedback matters.",
    id: 'NTu0VQ',
  },
  cancellationReason: {
    description: 'cancel subscription reason dropdown question',
    defaultMessage: 'Why are you planning to cancel?',
    id: 'eIU2EH',
  },
  chooseReason: {
    description: 'choose cancellation reason',
    defaultMessage: 'Choose Reason',
    id: '2Tfrf3',
  },
  couldntConnectStore: {
    description: 'cancel subscription reason: could not connect store',
    defaultMessage: 'Couldn’t connect to my store or shopping cart',
    id: 'pvGAor',
  },
  couldntConnectShippingProvider: {
    description: 'cancel subscription reason: could not connect shipping provider',
    defaultMessage: 'Couldn’t connect to my shipping provider',
    id: '7MNHqR',
  },
  noLongerNeedShipping: {
    description: 'cancel subscription reason: no longer need shipping',
    defaultMessage: 'No longer need shipping',
    id: 'LHEWSz',
  },
  missingFeatures: {
    description: 'cancel subscription reason: missing features',
    defaultMessage: 'Missing Features',
    id: 'djJGlV',
  },
  tooExpensive: {
    description: 'cancel subscription reason: too expensive',
    defaultMessage: 'Too Expensive',
    id: 'w/8JQ0',
  },
  printerIssues: {
    description: 'cancel subscription reason: printer issues',
    defaultMessage: 'Printer Issues',
    id: 'jwHfOo',
  },
  otherReason: {
    description: 'cancel subscription reason: other',
    defaultMessage: 'Other',
    id: '5Uofn3',
  },
  followUpPleaseTellUsMore: {
    description: 'cancel subscription reason: other, tell us more textbox',
    defaultMessage: 'Please tell us more',
    id: 'bGvdaW',
  },
  cancellationComments: {
    description: 'cancel subscription comments',
    defaultMessage: 'Comments',
    id: 'xCXb7+',
  },
  cancel: {
    description: 'cancel subscription close modal',
    defaultMessage: 'Cancel',
    id: 'rv+6tQ',
  },
  cancelPlans: {
    description: 'cancel plans button',
    defaultMessage: 'Next: Cancel {numberOfFreeStampsPlans, plural, one {Plan} other {Plans}}',
    id: '2hG6qI',
  },
  cancelSubscription: {
    description: 'cancel subscription button',
    defaultMessage: 'Cancel Subscription',
    id: 'zE5dqt',
  },
  howToResolveStampsAccount: {
    description: 'cancel subscription resolve stamps account heading',
    defaultMessage:
      'Before we can complete cancellation, please choose how to resolve your Stamps.com {numberOfFreeStampsPlans, plural, one {account} other {accounts}}:',
    id: 'e9qxn6',
  },
  cancelAndKeepStampsAccountOpen: {
    description: 'cancel subscription and keep stamps account open option',
    defaultMessage:
      'Cancel my ShipStation account but keep my Stamps.com {numberOfFreeStampsPlans, plural, one {account} other {accounts}} active with Core Plan at {stampsPrice} per month.',
    id: '3jQFun',
  },
  cancelPlanAndStampsAccount: {
    description: 'cancel subscription and close stamps account option',
    defaultMessage: 'Cancel my ShipStation account and my Stamps.com {numberOfFreeStampsPlans, plural, one {account} other {accounts}}.',
    id: 'IvalE7',
  },
  goBack: {
    description: 'cancel subscription go back button',
    defaultMessage: 'Go Back',
    id: 'HIuCrb',
  },
  keepSpecificStampsAccountOpen: {
    description: 'keep specific stamps account open checkbox',
    defaultMessage: 'Keep my Stamps account <b>{accountNickname}</b> active by subscribing to the Stamps Core Plan for {stampsPrice}',
    id: 'c15mz+',
  },
  moreThanOneStampsAccountMessagen: {
    description: 'keep specific stamps account open checkbox',
    defaultMessage:
      "You seem to have more than 1 Stamps account. Please choose which accounts you'd like to keep on the Stamps Core Plan at {stampsPrice} each:",
    id: 'aMNK/a',
  },
  followUpwhatStore: {
    description: 'could not connect store followup question',
    defaultMessage: 'What store or shopping cart were you trying to connect to?',
    id: 'zKIzeI',
  },
  followUpwhatProvider: {
    description: 'could not connect provider followup question',
    defaultMessage: 'What type of provider were you trying to connect to?',
    id: 'DoHmEa',
  },
  followUpInternationalProvider: {
    description: 'followup international provider answer',
    defaultMessage: 'International Provider',
    id: 'elokkv',
  },
  followUpDomesticProvider: {
    description: 'followup domestic provider answer',
    defaultMessage: 'Domestic or Regional Provider',
    id: 'cEfO2f',
  },
  followUpFreightProvider: {
    description: 'followup freight provider answer',
    defaultMessage: 'Freight Provider',
    id: 'BcfShS',
  },
  followUpOtherProvider: {
    description: 'followup other provider answer',
    defaultMessage: 'Other',
    id: '52XXUe',
  },
  followUpMissingfeature: {
    description: 'could not connect provider followup question',
    defaultMessage: 'Which features did you feel were missing?',
    id: 'cqiAFv',
  },
  followUpMissingInventory: {
    description: 'followup inventory features answer',
    defaultMessage: 'Inventory Features',
    id: 'w9niVm',
  },
  followUpMissingDropShip: {
    description: 'followup drop ship features answer',
    defaultMessage: 'Drop Ship Features',
    id: 'KhkHgh',
  },
  followUpMissingWorkflow: {
    description: 'followup unsupported workflow answer',
    defaultMessage: "Doesn't support my workflow",
    id: 'gIR5+b',
  },
  followUpMissingLabel: {
    description: 'followup missing label answer',
    defaultMessage: 'Label Size/Customization Features',
    id: 'i7vAz2',
  },
  followUpMissingOther: {
    description: 'followup missing other feature answer',
    defaultMessage: 'Other',
    id: 'dgL4+f',
  },
  followUpNoLongerShipping: {
    description: 'no longer shipping followup question',
    defaultMessage: 'Which best describes the change in your shipping needs?',
    id: 'HhgwFr',
  },
  followUpSeasonal: {
    description: 'followup no longer shipping temporarily/seasonally answer',
    defaultMessage: 'Stopped shipping seasonally/temporarily',
    id: 'N0deY/',
  },
  followUpPermanent: {
    description: 'followup no longer shipping permanently answer',
    defaultMessage: 'Stopped shipping permanently',
    id: '41xMza',
  },
  followUpLowVolume: {
    description: 'followup no longer shipping due to low volume answer',
    defaultMessage: 'Shipping a low volume',
    id: 'D2zvsJ',
  },
  followUpStopShippingOther: {
    description: 'followup no longer shipping other answer',
    defaultMessage: 'Other',
    id: 'vxqxtE',
  },
  followUpTooExpensive: {
    description: 'too expensive followup question about shipment volume',
    defaultMessage: 'How many shipments do you typically do a month?',
    id: 'PlBNe4',
  },
  followUp0To25PerMonth: {
    description: 'followup too expensive shipping volume is 0 - 25 per month answer',
    defaultMessage: '0 - 25',
    id: 'dBXSbp',
  },
  followUp26To50PerMonth: {
    description: 'followup too expensive shipping volume is 26 - 50 per month answer',
    defaultMessage: '26 - 50',
    id: '6amgBE',
  },
  followUp51To100PerMonth: {
    description: 'followup too expensive shipping volume is 51 - 100 per month answer',
    defaultMessage: '51 - 100',
    id: 'mwW5aw',
  },
  followUpOver100PerMonth: {
    description: 'followup too expensive shipping volume is over 100 per month answer',
    defaultMessage: 'Over 100',
    id: 'aXqA9+',
  },
  followUpPrinterIssues: {
    description: 'printer issues followup question about specific issues',
    defaultMessage: 'Please describe what types of printer issues you were experiencing.',
    id: 'lF5e5r',
  },
  cancellationRequestError: {
    description: 'error notification if cancellation request fails',
    defaultMessage: 'Error cancelling subscription, please try again.',
    id: 's4gsor',
  },
  getCancellationInfoError: {
    description: 'error notification if get cancellation info request fails',
    defaultMessage: 'Error fetching cancellation information, please try again.',
    id: 'QfJLR2',
  },
  getSubscriptionInfoError: {
    description: 'error notification if get subscription info request fails',
    defaultMessage: 'Error fetching subscription information, please try again.',
    id: 'ev1RB7',
  },
  editSubscriptionBilling: {
    description: 'Edit Subscription Billing modal title',
    defaultMessage: 'Edit Subscription Billing',
    id: 'GHvLmC',
  },
  editShipstationBalance: {
    description: 'Edit ShipStation Balance modal title',
    defaultMessage: 'Edit ShipStation Balance',
    id: 'Dzik1e',
  },
  billingInfoConfirmCancelBody: {
    description: 'Body text to confirm closing billing info modal',
    defaultMessage: 'Did you want to close without saving?',
    id: 'ntdYWh',
  },
  billingInfoConfirmCancelButton: {
    description: 'Button text to confirm closing billing info modal',
    defaultMessage: 'Exit',
    id: 'eiS6ge',
  },
  billingInfoConfirmCancelHeader: {
    description: 'Header text to confirm closing billing info modal',
    defaultMessage: 'Exit Payment Information',
    id: 'Hl3c0D',
  },
  save: {
    description: 'billing modal save buttom',
    defaultMessage: 'Save',
    id: 'w1gIRO',
  },
  close: {
    description: 'billing modal close button',
    defaultMessage: 'Close',
    id: 'qpH7Sk',
  },

  downgradeButtonText: {
    defaultMessage: 'Downgrade Plan',
    description: 'Button text to confirm the downgrade',
    id: 'UglSdy',
  },
  contactUKSales: {
    description: 'billing modal Contact UK Sales link',
    defaultMessage: 'Contact Sales: +44 (0)20 8068 5522',
    id: 'ZiPy/T',
  },
  contactEUSales: {
    description: 'billing modal Contact EU Sales link',
    defaultMessage: 'Contact Sales: <link>{salesEmail}</link>{br} {salesPhoneNumber}',
    id: 'z2S5W6',
  },
  contactNZSales: {
    description: 'billing modal Contact NZ Sales link',
    defaultMessage: 'Contact Sales: (+) 64 09-886 5534',
    id: 'Vbfg4j',
  },
  contactAUSales: {
    description: 'billing modal Contact AU Sales link',
    defaultMessage: 'Contact Sales: (02) 4641 0020',
    id: 'UUL+C6',
  },
  payPalMethod: {
    description: 'PayPal billing Method',
    defaultMessage: 'PayPal',
    id: 'Fekoq7',
  },
  creditCardMethod: {
    description: 'Credit Card billing Method',
    defaultMessage: 'Credit Card',
    id: 'ufG0kt',
  },
  payPalBillingEmailTooltip: {
    description: 'PayPal billing email tooltip message',
    defaultMessage: 'Billing communications will be sent to your ShipStation account email.',
    id: 'bZO33R',
  },
  billingEmailMessage: {
    description: 'Header used to display the merchant billing email',
    defaultMessage: 'Billing communications will be sent to the email below:',
    id: 'QUs09m',
  },
  editBillingEmailButton: {
    description: 'Edit billing email button',
    defaultMessage: 'Edit Billing Email',
    id: 'wNVHbl',
  },
  paypalBillingError: {
    description: 'Error message when setting up PayPal billing',
    defaultMessage: 'Error updating PayPal billing information, please try again.',
    id: 'LqKDRH',
  },
  updateBillingError: {
    description: 'Error message when updating billing',
    defaultMessage: 'Error updating billing information, please try again.',
    id: 'l8TPB+',
  },
  noBillingAddress: {
    description: 'Error message when no billing address is entered',
    defaultMessage: 'Please update the billing address and try again.',
    id: '/r/UR5',
  },
  noPhoneNumber: {
    description: 'Error message when no phone number is entered',
    defaultMessage: 'Please enter a phone number and try again.',
    id: '3cj15R',
  },
  failedUpdatePBSBillingInfo: {
    description: 'Error message when updating PBS billing information failed',
    defaultMessage: 'Error updating billing information, please try to edit the saved payment method or try again.',
    id: 'O8Hm6V',
  },
  billingEmail: {
    description: 'Billing Email field label',
    defaultMessage: '<b>Billing Email</b>',
    id: '+YAteX',
  },
  updateBillingEmail: {
    description: 'Update Billing Email modal label',
    defaultMessage: 'Update Billing Email',
    id: '6qALkG',
  },
  updateBillingEmailError: {
    description: 'Error message when updating billing email',
    defaultMessage: 'Error updating billing email, please try again.',
    id: 'ZEegM7',
  },
  otherOptionInfoBanner: {
    description: 'Extra directions when other option is selected',
    defaultMessage: 'Please include a brief explanation to help us improve.',
    id: 'NnjrSH',
  },
  cancelSubscriptionText: {
    description: 'cancel subscription link',
    defaultMessage: 'Cancel Subscription',
    id: 'Tt8VEI',
  },
  subscriptionaddOnModalHeader: {
    description: 'Header for subscription add on modal',
    defaultMessage: 'Subscription Add-ons',
    id: 'ldn3na',
  },
  threePLAddon: {
    description: '3PL add on header',
    defaultMessage: 'Third Party Fulfillment Provider Bundle',
    id: '2lc7BC',
  },
  noAddonsText: {
    description: 'link text to indicate user has available additional features to add to their account',
    defaultMessage: 'Add-ons Available',
    id: 'R/PqYV',
  },
  addons3PLHeader: {
    description: 'Add ons modal 3PL header',
    defaultMessage: 'Third-Party Fulfillment Provider Bundle',
    id: 'TYrGWo',
  },
  closeAccount: {
    description: 'Opens cancel subscription modal for trial users',
    defaultMessage: 'Close Account',
    id: '0v3zBI',
  },
  noPaymentInfoError: {
    description: 'Error message displayed when no payment credentials available when changing subscription',
    defaultMessage: 'Please enter valid payment information to continue updating subscription',
    id: 'vRplCn',
  },
  invalidPaymentInfoError: {
    description: 'Error message displayed when invalid payment credentials',
    defaultMessage: 'Please verify that the billing information is correct or use a different card.',
    id: 'hqkb4/',
  },
  invalidPostalCodeError: {
    description: 'Error message displayed when postal code is invalid',
    defaultMessage: 'Postal code is invalid',
    id: 'coZQMg',
  },
  invalidAddressError: {
    description: 'Error message displayed when address is invalid',
    defaultMessage: 'Address is invalid',
    id: 'p54uLe',
  },
  invalidCityError: {
    description: 'Error message displayed when city is invalid',
    defaultMessage: 'City is invalid',
    id: 'QMFeGz',
  },
  invalidStateError: {
    description: 'Error message displayed when state is invalid',
    defaultMessage: 'State is invalid',
    id: 'bH8p1F',
  },
  invalidPhoneError: {
    description: 'Error message displayed when phone is invalid',
    defaultMessage: 'Phone is invalid',
    id: 'cZmaS0',
  },
  selectAddress: {
    description: 'Edit payment method modal radio buttons title',
    defaultMessage: 'Select Address',
    id: '2UL+vH',
  },
  nickname: {
    description: 'Nickname input field title',
    defaultMessage: 'Nickname',
    id: 'ygMYJ7',
  },
  nicknameDisclaimer: {
    description: 'Subtext to explain where nickname will be used',
    defaultMessage: 'The nickname is used to identify this payment method throughout the app.',
    id: 'GHP/5y',
  },
  paymentMethodType: {
    description: 'payment method type header',
    defaultMessage: 'Payment Method Type',
    id: '27LhG/',
  },
  nicknameError: {
    description: 'payment modal nickname error',
    defaultMessage: 'Nickname must not be blank',
    id: 'XzMvjU',
  },
  monthlyShipmentsLabel: {
    description: 'Label for the monthly shipments dropdown',
    defaultMessage: 'Monthly shipments',
    id: 'bg9qI0',
  },
  yourCarriersAddOnPrice: {
    description: 'Bring Your Own Accounts add on charge per plan',
    defaultMessage: 'Your Carriers',
    id: 'YS0Dua',
  },
  processingNotificationTitle: {
    description: 'header to indicate that tax ID validation is being processed',
    defaultMessage: 'Processing',
    id: 'alwJLS',
  },
  processingNotificationDescription: {
    description: 'description to indicate that tax ID validation is being validated',
    defaultMessage: 'Your {taxIdName} is being validated. This can take a moment',
    id: 'yIGzSh',
  },
  successNotificationTitle: {
    description: 'header to indicate that tax ID was successfully added',
    defaultMessage: 'Successfully Added',
    id: 'olBLk6',
  },
  successNotificationDescription: {
    description: 'description to indicate that tax ID was successfully added',
    defaultMessage: "You've successfully saved your {taxIdName} to your account",
    id: 'pl+N33',
  },
  validationErrorNotificationTitle: {
    description: 'header to indicate that there was an error when validating tax ID',
    defaultMessage: 'Validation Error',
    id: 'O5F6Sk',
  },
  validationErrorNotificationDescription: {
    description: 'description to indicate that there was an error when validating tax ID',
    defaultMessage:
      'The {taxIdName} you provided has failed validation. Please verify the details are accurate and up to date, then resubmit your request',
    id: 'opNZmz',
  },
  deactivateUsersHeader: {
    id: '3vAUYl',
    defaultMessage: 'Deactivate users before downgrading',
    description: 'Header for the deactivate users modal',
  },
  downgradeWarning: {
    id: 'LjGK7M',
    defaultMessage: 'Downgrading your plan will remove user role controls—any users you keep will automatically receive admin access.',
    description: 'Warning about downgrading plan effects on user roles',
  },
  userLimitDescription: {
    id: 'lWbcKV',
    defaultMessage:
      "You're currently using more seats than your chosen plan allows. To proceed with this downgrade, please deactivate the excess user accounts. Once you've reduced your active users to the maximum allowed, you may be able to confirm your plan change.",
    description: 'Description of user limit requirements for downgrading',
  },
  maxAllowedUsers: {
    id: '25PL6p',
    defaultMessage: 'Max allowed active users: {maxAllowedUsers}',
    description: 'Label for maximum allowed active users',
  },
  currentActiveUsers: {
    id: '/lu3n1',
    defaultMessage: 'Current active users: {currentActiveUsers}',
    description: 'Label for current active users count',
  },
  statusColumnHeader: {
    id: 'HQFQcn',
    defaultMessage: 'Status',
    description: 'Status column header in users table',
  },
  activeStatus: {
    id: 'w0wBwK',
    defaultMessage: 'Active',
    description: 'Active status label',
  },
  actions: {
    defaultMessage: 'Actions',
    id: 'szBbSp',
    description: 'Payment and subscription payments table actions ',
  },
  skipForNow: {
    id: 'L/L3/L',
    defaultMessage: 'Skip For Now',
    description: 'Button text to skip user deactivation and proceed with plan change',
  },
  skipForNowTooltip: {
    id: 'Oi+Qg5',
    defaultMessage: 'App usage will be blocked after plan change until users are deactivated',
    description: 'Tooltip for Skip For Now button explaining consequences',
  },
  subscriptionInsuranceTab: {
    id: 'cs4jeM',
    description: 'Tab label for subscription invoices',
    defaultMessage: 'Subscription',
  },
  freightInvoicesTab: {
    id: 'CAfQUS',
    description: 'Tab label for freight invoices',
    defaultMessage: 'Freight Invoices',
  },
  freightInvoicesDescription: {
    id: 'sREcaa',
    description: 'Description text for the freight invoices tab',
    defaultMessage: 'These invoices represent your freight shipping charges.',
  },
  freightColumnDate: {
    id: 'sdFs8V',
    description: 'Freight invoices grid Date column header',
    defaultMessage: 'Date',
  },
  freightColumnInvoiceNumber: {
    id: 'oWUrrD',
    description: 'Freight invoices grid Invoice # column header',
    defaultMessage: 'Invoice #',
  },
  freightColumnInvoiceAmount: {
    id: 'F+63tO',
    description: 'Freight invoices grid Invoice Amount column header',
    defaultMessage: 'Invoice Amount',
  },
  freightColumnAmountDue: {
    id: 'PNQ0Ja',
    description: 'Freight invoices grid Amount Due column header',
    defaultMessage: 'Amount Due',
  },
  freightColumnPaymentApplied: {
    id: 'rBTia9',
    description: 'Freight invoices grid Payment Applied column header',
    defaultMessage: 'Payment Applied',
  },
  freightColumnCreditApplied: {
    id: '1SX3q8',
    description: 'Freight invoices grid Credit Applied column header',
    defaultMessage: 'Credit Applied',
  },
  freightColumnType: {
    id: 'LGfX/v',
    description: 'Freight invoices grid Type column header',
    defaultMessage: 'Type',
  },
  freightColumnStatus: {
    id: 'tFYoOF',
    description: 'Freight invoices grid Status column header',
    defaultMessage: 'Status',
  },
  freightColumnActions: {
    id: 'dfHlYC',
    description: 'Freight invoices grid Actions column header',
    defaultMessage: 'Actions',
  },
  freightDateFilterAll: {
    id: 'gBJkme',
    description: 'Freight invoices date filter - all option',
    defaultMessage: 'All',
  },
  freightDateFilterLast30Days: {
    id: 's2Z1VV',
    description: 'Freight invoices date filter - last 30 days option',
    defaultMessage: 'Last 30 days',
  },
  freightDateFilterLast60Days: {
    id: 'BjkDKH',
    description: 'Freight invoices date filter - last 60 days option',
    defaultMessage: 'Last 60 days',
  },
  freightDateFilterLast90Days: {
    id: '0DA68b',
    description: 'Freight invoices date filter - last 90 days option',
    defaultMessage: 'Last 90 days',
  },
  freightFilterInvoiceDate: {
    id: 'WiQruP',
    description: 'Freight invoices filter label for Invoice Date',
    defaultMessage: 'Invoice Date',
  },
  freightFilterStatus: {
    id: '2GGWGb',
    description: 'Freight invoices filter label for Status',
    defaultMessage: 'Status',
  },
  freightTypeFreight: {
    id: 'p2N+iG',
    description: 'Freight invoices type filter - freight option',
    defaultMessage: 'Freight',
  },
  freightTypeParcel: {
    id: 'FLwVZu',
    description: 'Freight invoices type filter - parcel option',
    defaultMessage: 'Parcel',
  },
  freightStatusAll: {
    id: '31bG37',
    description: 'Freight invoices status filter - all option',
    defaultMessage: 'All',
  },
  freightStatusAvailableToPay: {
    id: 'J6XbmS',
    description: 'Freight invoices status - available to pay',
    defaultMessage: 'Available to Pay',
  },
  freightStatusOnHold: {
    id: 'UybQ+T',
    description: 'Freight invoices status filter - on hold',
    defaultMessage: 'On Hold',
  },
  freightStatusCreditBalance: {
    id: '11xseM',
    description: 'Freight invoices status filter - credit balance',
    defaultMessage: 'Credit Balance',
  },
  freightStatusPaid: {
    id: 'ugQ3y3',
    description: 'Freight invoices status - paid',
    defaultMessage: 'Paid',
  },
  freightDownload: {
    id: 'Y7Sbhk',
    description: 'Freight invoices download action button label',
    defaultMessage: 'Download',
  },
  freightInvoicesError: {
    id: 'H71wr/',
    description: 'Error message shown when freight invoices fail to load',
    defaultMessage: 'Failed to load freight invoices. Please try again.',
  },
  freightNoProvidersConnected: {
    id: '+2bA2V',
    description: 'Message shown when no freight providers are connected. "link" wraps the Settings link.',
    defaultMessage: 'No freight providers are connected. Connect a freight provider in <link>Settings</link> to view invoices.',
  },
  freightEmptyState: {
    id: 'xjBAUb',
    description: 'Message shown when freight invoices list is empty',
    defaultMessage: 'No freight invoices found.',
  },
  freightProviderLabel: {
    id: 'HY6fgv',
    description: 'Label for the freight provider selector dropdown',
    defaultMessage: 'Provider',
  },
  freightDownloadError: {
    id: 'PB2QRQ',
    description: 'Generic error shown when a freight invoice download fails',
    defaultMessage: 'Failed to download invoice. Please try again.',
  },
  freightStatusCreated: {
    id: '+BxLsD',
    description: 'Freight invoice status — Created',
    defaultMessage: 'Created',
  },
  freightStatusPending: {
    id: '+L5FAp',
    description: 'Freight invoice status — Pending',
    defaultMessage: 'Pending',
  },
  freightStatusVoid: {
    id: 'N9DmOL',
    description: 'Freight invoice status — Void',
    defaultMessage: 'Void',
  },
  freightStatusDisputed: {
    id: 't5Wc0z',
    description: 'Freight invoice status — Disputed',
    defaultMessage: 'Disputed',
  },
  freightStatusInCollections: {
    id: 'hScA5R',
    description: 'Freight invoice status — In Collections',
    defaultMessage: 'In Collections',
  },
  freightStatusRebill: {
    id: 'vu8CFS',
    description: 'Freight invoice status — Rebill',
    defaultMessage: 'Rebill',
  },
  freightStatusGenerated: {
    id: 'mSgmIV',
    description: 'Freight invoice status — Generated',
    defaultMessage: 'Generated',
  },
  freightStatusOpen: {
    id: '3ihaY4',
    description: 'Freight invoice status — Open',
    defaultMessage: 'Open',
  },
  freightStatusNew: {
    id: 'EA51sc',
    description: 'Freight invoice status — New',
    defaultMessage: 'New',
  },
  freightStatusNa: {
    id: 'eHeHkj',
    description: 'Freight invoice status — N/A',
    defaultMessage: 'N/A',
  },
});

export const cancelReasonMap = {
  0: messages.chooseReason,
  1: messages.couldntConnectStore,
  2: messages.couldntConnectShippingProvider,
  3: messages.missingFeatures,
  4: messages.noLongerNeedShipping,
  5: messages.tooExpensive,
  6: messages.printerIssues,
  7: messages.otherReason,
};

export const followUpCancelReasonMap = {
  0: messages.chooseReason,
  1: messages.followUpwhatStore,
  2: messages.followUpwhatProvider,
  3: messages.followUpMissingfeature,
  4: messages.followUpNoLongerShipping,
  5: messages.followUpTooExpensive,
  6: messages.followUpPrinterIssues,
  7: messages.followUpPleaseTellUsMore,
};

export const followUpReasons = {
  0: messages.chooseReason,
  1: messages.followUpInternationalProvider,
  2: messages.followUpDomesticProvider,
  3: messages.followUpFreightProvider,
  4: messages.followUpOtherProvider,
  5: messages.followUpMissingInventory,
  6: messages.followUpMissingDropShip,
  7: messages.followUpMissingWorkflow,
  8: messages.followUpMissingLabel,
  9: messages.followUpMissingOther,
  10: messages.followUpSeasonal,
  11: messages.followUpPermanent,
  12: messages.followUpLowVolume,
  13: messages.followUpStopShippingOther,
  14: messages.followUp0To25PerMonth,
  15: messages.followUp26To50PerMonth,
  16: messages.followUp51To100PerMonth,
  17: messages.followUpOver100PerMonth,
};

export const paymentTableMessages = defineMessages({
  title: {
    defaultMessage: 'Payment Methods',
    id: 'HEmGwY',
    description: 'Payment and subscription payments table header title',
  },
  paymentSettingsTitle: {
    defaultMessage: 'Payment Settings',
    id: 'f/GaQ1',
    description: 'Payment and subscription payments table header title settings',
  },
  paysForHeader: {
    defaultMessage: 'Pays For',
    id: 'EwUwrK',
    description: 'Payment and subscription payments table pays for header',
  },
  paymentMethod: {
    defaultMessage: 'Payment Method',
    id: 'ORTCp4',
    description: 'Payment and subscription payments table payment method header',
  },
  type: {
    defaultMessage: 'Type',
    id: 'q6yKec',
    description: 'Payment and subscription payments table type header',
  },
  actions: {
    defaultMessage: 'Actions',
    id: 'szBbSp',
    description: 'Payment and subscription payments table actions ',
  },
  updatePaymentMethod: {
    defaultMessage: 'Update Payment Method',
    id: 'Ps+2tv',
    description: 'Payment and subscription payments table actions to edit payment',
  },
  activateAccount: {
    defaultMessage: 'Activate',
    id: 'LXnnSm',
    description: 'Payment and subscription payments table actions to activate a new account',
  },
  addPaymentMethod: {
    defaultMessage: 'Add Payment Method',
    id: '7cnQaC',
    description: 'Payment and subscription payments table actions to add a new card to the subscription section',
  },
  creditCard: {
    defaultMessage: 'Credit Card',
    id: 'xlKlON',
    description: 'Payment and subscription payments table credit card type',
  },
  payPal: {
    defaultMessage: 'PayPal',
    id: 'kwkj3Z',
    description: 'Payment and subscription payments table payPal type',
  },
  ach: {
    defaultMessage: 'Bank Account',
    id: '76mMpD',
    description: 'Payment and subscription payments table ACH type',
  },
  shipstationBalance: {
    defaultMessage: 'ShipStation Balance',
    id: 'Ox3qGI',
    description: 'Payment and subscription payments table Shipstation Balance section',
  },
  shipstationBalanceTooltip: {
    defaultMessage: 'For ShipStation Carrier labels and their related fees',
    id: 'mSTMC+',
    description: 'Payment and subscription payments table Shipstation Balance section',
  },
  subscriptionAndShipsuranceTooltip: {
    defaultMessage: 'For monthly plan fees and Shipsurance balance',
    id: '6wxlhG',
    description: 'Payment and subscription payments table Subscription and Shipsurance section',
  },
  shipsuranceBalance: {
    defaultMessage: 'Subscription & Shipsurance',
    id: 'kXfS+O',
    description: 'Payment and subscription payments table subscription and shipsurance section',
  },
  subscriptionBalance: {
    defaultMessage: 'Subscription',
    id: '0rJ/eK',
    description: 'Payment and subscription payments table subscription and shipsurance section',
  },
  freightShipping: {
    defaultMessage: 'Shipment Invoice',
    id: 'o2hkIj',
    description: 'Payment and subscription payments table Shipment Invoice section',
  },
  walletUpdatePaymentMethodSuccessContent: {
    description: 'Content for notification for successfully updating payment info',
    defaultMessage: 'The billing information for your ShipStation Balance has been updated.',
    id: 'L5NEnh',
  },
  walletUpdatePaymentMethodSuccessHeader: {
    description: 'Header for notification for successfully updating payment info',
    defaultMessage: 'Success',
    id: '9gc6nJ',
  },
  managePaymentMethod: {
    defaultMessage: 'Manage',
    id: 'QpjZS/',
    description: 'Payment and subscription payments table actions to manage payment method',
  },
  choosePlan: {
    description: 'button for trials to choose a plan',
    defaultMessage: 'Choose Plan',
    id: 'vmiYQp',
  },
  paymentMethodUpdateSuccessTitle: {
    description: 'title for successful payment method update',
    defaultMessage: 'Payment Method Updated!',
    id: 'BcNo3m',
  },
  paymentMethodUpdateSuccessMessage: {
    description: 'content for successful payment method update',
    defaultMessage: 'Payment method updated successfully!',
    id: 'VkuNOl',
  },
  paymentMethodUpdateErrorTitle: {
    description: 'title for failed payment method update',
    defaultMessage: 'Payment Method Update Failed',
    id: '1Mzwo7',
  },
  paymentMethodUpdateErrorMessage: {
    description: 'content for failed payment method update',
    defaultMessage: 'There was an error updating your payment method. Please try again.',
    id: 'rm/XHW',
  },
});
